import React from "react";
import { toast } from "react-toastify";

// Assets
import IOne21 from "assets/one21.png";
import ISofiaText from "assets/i-sofia-text";
import ISofiaV2 from "assets/i-sofia-v2";
import ISofia from "assets/i-sofia";
import IPlus from "assets/i-plus";
import IShare from "assets/i-share";

// Ctx
import { SofiaMagicStudioProvider } from "contexts/sofia-magic-studio-ctx";
import { useGlobalCtx } from "contexts/GlobalContext";

// API
import {
  useGetSofiaBalance,
  useGetPaymentStatus,
  usePostShareCredit,
} from "api/sofia-magic-studio";

// Component
import Button from "components/v1/Button";
import ListListingOrganism from "components/organism/sofia-magic-studio/list-listing";
import ModalTambahKredit from "components/molecules/sofia-magic-studio/modal-tambah-kredit";
import ModalTambahKreditDetail from "components/molecules/sofia-magic-studio/modal-tambah-kredit-detail";
import ModalKonfirmasi from "components/molecules/sofia-magic-studio/modal-result";
import ModalShareCredit from "components/molecules/sofia-magic-studio/modal-share-credit";
import ModalResult from "components/molecules/sofia-magic-studio/modal-result";
import ModalResultTopUp from "components/molecules/sofia-magic-studio/modal-result-topup";
import ModalCreditHistory from "components/molecules/sofia-magic-studio/modal-credit-history";

const RenderZeroBalance = ({ onBuyCredit }) => {
  return (
    <div className="flex items-center justify-center gap-2">
      <p className="text-[13px] tracker-[-0.4px] leading-[21.034px] font-inter text-[#808285]">
        Belum bisa rapikan foto?
      </p>
      <Button
        className="!bg-[#1B67DA] !text-white"
        type="secondary"
        size="s"
        text="Tambah Kredit"
        icon={ISofiaV2}
        onClick={onBuyCredit}
      />
    </div>
  );
};

const RenderHasBalance = ({ balance, onBuyCredit, onShareCredit, onViewHistory }) => {
  return (
    <div className="flex items-center justify-center gap-2">
      <div className="flex items-center gap-1 cursor-pointer" onClick={onViewHistory}>
        <ISofia />
        <span className="text-[13px] tracker-[-0.4px] leading-[21.034px] font-inter text-[#252526]">
          {balance?.toLocaleString("id-ID") || "0"}
        </span>
        <span className="text-[13px] tracker-[-0.4px] leading-[21.034px] font-inter text-[#808285]">
          kredit
        </span>
      </div>
      <div className="flex items-center gap-1">
        <Button
          className="!w-8 !h-8 !p-[10px]"
          type="secondary"
          size="s"
          icon={IPlus}
          iconColor="#252526"
          onClick={onBuyCredit}
        />
        <Button
          className="!w-8 !h-8 !p-[10px]"
          type="secondary"
          size="s"
          icon={IShare}
          onClick={onShareCredit}
        />
      </div>
    </div>
  );
};

const RenderHasPayment = ({ paymentUrl }) => {
  const handlePay = () => {
    window.open(paymentUrl, "_blank");
  };
  return (
    <div className="flex items-center justify-center gap-2">
      <p className="text-[13px] tracker-[-0.4px] leading-[21.034px] font-inter text-[#808285]">
        Pembayaran menunggu: <span className="text-[#252526]">01:24:32</span>
      </p>
      <Button
        className="!bg-[#1B67DA] !text-white"
        type="secondary"
        size="s"
        text="Bayar Sekarang"
        icon={ISofiaV2}
        onClick={handlePay}
      />
    </div>
  );
};

const ListListing = () => {
  const { profile } = useGlobalCtx();
  const [isOpenModal, setIsOpenModal] = React.useState(""); // "kredit" | "payment" | "share" | "success" | "history"
  const [selectedPackage, setSelectedPackage] = React.useState(null);

  const {
    data: balanceData,
    isLoading: isLoadingBalance,
    refetch,
  } = useGetSofiaBalance();
  const {
    data: paymentStatusData,
    isLoading: isLoadingPaymentStatus,
    refetch: refetchPaymentStatus,
  } = useGetPaymentStatus();

  const { mutate: mutatePostShareCredit } = usePostShareCredit();

  const balance = balanceData?.data?.data?.balance_credits || 0;
  const statusPayment = paymentStatusData?.data?.data;
  const hasPayment = statusPayment?.status === "pending";

  const handleCloseModal = () => {
    setIsOpenModal("");
    setSelectedPackage(null);
    refetch();
    refetchPaymentStatus();
  };

  const handleOpenModal = (type) => {
    setIsOpenModal(type);
  };

  const handleSelectPackage = (pkg) => {
    setSelectedPackage(pkg);
    setIsOpenModal("payment");
  };

  const handleShareCredit = (data) => {
    const payload = {
      credits: data.credits,
      user_id: data.user_id,
    };
    mutatePostShareCredit(
      { data: payload },
      {
        onSuccess: () => {
          setIsOpenModal("result");
        },
        onError: (error) => {
          toast.error(error?.response?.data?.message || "Gagal share kredit");
        },
      }
    );
  };

  return (
    <>
      <div className="wrapper nav-content-wrapper bg-[#E6E7E8]">
        <div className="px-6 py-[14px] bg-white flex items-center justify-between">
          <ISofiaText />

          {isLoadingBalance || isLoadingPaymentStatus ? (
            <p className="text-[13px] text-[#808285]">Memuat...</p>
          ) : balance === 0 ? (
            <RenderZeroBalance onBuyCredit={() => handleOpenModal("kredit")} />
          ) : (
            <RenderHasBalance
              balance={balance}
              onBuyCredit={() => handleOpenModal("kredit")}
              onShareCredit={() => handleOpenModal("share")}
              onViewHistory={() => handleOpenModal("history")}
            />
          )}
        </div>
        <div className="p-6">
          <ListListingOrganism />
        </div>

        <div className="flex items-center justify-between px-6 py-[14px] border-t border-solid border-[#D8D8D9]">
          <p className="text-[13px] tracker-[-0.4px] leading-[21.034px] font-inter text-[#252526]">
            CENTURY 21 {profile?.company?.name}{" "}
            <span className="text-[#808285]">© 2026.</span>
          </p>

          <div className="flex items-center gap-1">
            <p className="text-[13px] tracker-[-0.4px] leading-[21.034px] font-inter text-[#808285]">
              Powered by
            </p>
            <img
              className="w-[43.922px] h-[43.922px] object-contain"
              src={IOne21}
              alt="one21"
            />
          </div>
        </div>
      </div>
      <ModalTambahKredit
        onSelect={handleSelectPackage}
        isOpen={isOpenModal === "kredit"}
        onClose={handleCloseModal}
      />
      <ModalTambahKreditDetail
        selectedPackage={selectedPackage}
        isOpen={isOpenModal === "payment"}
        onClose={handleCloseModal}
        onBack={() => handleOpenModal("kredit")}
        onSuccess={() => handleOpenModal("success")}
      />
      <ModalResultTopUp
        isOpen={isOpenModal === "success"}
        onClose={handleCloseModal}
      />
      <ModalShareCredit
        isOpen={isOpenModal === "share"}
        onClose={handleCloseModal}
        balance={balance}
        onSubmit={handleShareCredit}
      />
      <ModalResult
        isOpen={isOpenModal === "result"}
        onClose={handleCloseModal}
        title="Berhasil membagikan kredit"
        description="Kredit yang dipilih sudah berhasil didistribusikan ke marketing kantor."
        leftBtnText="Kembali"
        rightBtnText="Selesai"
        rightBtnAction={handleCloseModal}
        rightBtnVariant="primary"
      />
      <ModalCreditHistory
        isOpen={isOpenModal === "history"}
        onClose={handleCloseModal}
        balance={balance}
      />
    </>
  );
};

const Wrapper = () => {
  return (
    <SofiaMagicStudioProvider>
      <ListListing />
    </SofiaMagicStudioProvider>
  );
};

export default Wrapper;
